// 기기 명령 목록 — Device Hub 와 Devices 상세 화면이 함께 사용
export const COMMANDS = [
  { value: 'restart_app', label: 'Restart App' },
  { value: 'clear_cache', label: 'Clear Cache' },
  { value: 'request_screenshot', label: 'Screenshot' },
  { value: 'enable_diag', label: 'Toggle Diagnostics' },
  { value: 'update_apk', label: 'Update APK' },
  { value: 'reboot', label: 'Reboot Device (RK/general only)' },
  // 2.13.6+: 결과는 기기 상세 "로그" 탭. 이전 버전은 실패(unknown) 또는 무시
  { value: 'collect_logs', label: 'Collect Logs (2.13.6+)' },
  { value: 'report_status', label: 'Report Status Now (2.13.6+)' },
  // set_ui: 앱 UI 요소 표시 제어 (2.13.4+). payload 는 기기에 영구 저장됨
  { value: 'set_ui:hide_pairing', label: 'Hide Remote Pairing Guide', command: 'set_ui', payload: { pairingGuide: false } },
  { value: 'set_ui:show_pairing', label: 'Show Remote Pairing Guide', command: 'set_ui', payload: { pairingGuide: true } },
  // lockdown: Device Owner 키오스크 잠금 수준 (2.14.0+, 기기가 Device Owner 일 때만 효과)
  { value: 'lockdown:0', label: 'Kiosk Lockdown: OFF (level 0)', command: 'lockdown', payload: { level: 0 } },
  { value: 'lockdown:1', label: 'Kiosk Lockdown: TEST (level 1, adb install allowed)', command: 'lockdown', payload: { level: 1 } },
  { value: 'lockdown:2', label: 'Kiosk Lockdown: PRODUCTION (level 2, block installs)', command: 'lockdown', payload: { level: 2 } },
];

// COMMANDS 항목 → 서버 요청 본문 ({ command, payload })
export const toCommandBody = (value) => {
  const c = COMMANDS.find(x => x.value === value);
  return c?.command ? { command: c.command, payload: c.payload || {} } : { command: value };
};
